import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import {AuthService} from '../auth.service';
import {NavigationService} from '../../shared/navigation.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private navigation: NavigationService) {
  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.authService.isAuthenticated()) {
      return true;
    }  else {
      this.navigation.login().go();
    }
    return false;
  }
}
